import DateUtils from "@/helpers/DateUtils.js";

export default class Resource {
	constructor({
		id,
		additional_info,
		email,
		identification,
		lastname,
		name,
		role_id,
		status_id,
		typology_id,
		username,
		alias,
		status,
		img_url,
		activity_id,
		group_id,
		visit_point_id,
	}) {
		this.additional_info = additional_info ? additional_info : {};
		this.email = email ? email.toLocaleLowerCase() : "";
		this.identification = identification ? identification : "";
		this.lastname = lastname ? lastname.toLocaleLowerCase() : "";
		this.name = name ? name.toLocaleLowerCase() : "";
		this.role_id = role_id ? role_id : 0;
		// El necesario enviar estatus id en null para no afectar la creacion de un recurso admin
		this.status_id = status_id ? status_id : null;
		this.typology_id = typology_id ? typology_id : 0;
		this.username = username ? username : "";
		this.id = id ? id : 0;
		if (alias) {
			this.alias = alias;
		}
		if (status) {
			this.alias = status;
		}
		this.img_url = img_url || "";
		this.activity_id = activity_id || [];
		this.group_id = group_id || [];
		this.visit_point_id = visit_point_id || [];
	}

	validateResource() {
		let valid = true;
		let invalidFields = [];
		for (const key in this) {
			if (Object.hasOwnProperty.call(this, key)) {
				const element = this[key];

				if (typeof element === "string" && element === "" && key !== "img_url") {
					invalidFields.push(`Resource.${key}Required`);
					valid = false;
				}
				if (typeof element === "number" && element <= 0 && key !== "typology_id") {
					invalidFields.push(key);
					valid = false;
				}
				if (key === "email" && !this.validateEmail()) {
					invalidFields.push("Resource.EmailInvalid");
					valid = false;
				}

				if (key === "username" && !this.validateLength(key)) {
					invalidFields.push("Resource.UsernameInvalid");
					valid = false;
				}
			}
		}
		return {valid, invalidFields};
	}

	validateResourceData() {
		let valid = true;
		let invalidFields = [];
		for (const key in this) {
			if (Object.hasOwnProperty.call(this, key)) {
				const element = this[key];
				if (typeof element === "string" && element === "" && key !== "img_url") {
					invalidFields.push(`Resource.${key}Required`);
					valid = false;
				}

				if (key === "email" && !this.validateEmail()) {
					invalidFields.push("Resource.EmailInvalid");
					valid = false;
				}

				if (key === "username" && !this.validateLength(key)) {
					invalidFields.push("Resource.UsernameInvalid");
					valid = false;
				}
			}
		}
		return {valid, invalidFields};
	}

	validateEmail() {
		const emailPattern =
			/^([a-z0-9-+*=&'/?^_}{~|`]+)(\.?[a-z0-9-+*=&'/?^_}{~|`]+)*@[a-z0-9]+((-|\.)[a-z0-9]+)*(\.[a-z]{1,20})$/;
		return emailPattern.test(this.email);
	}

	validateLength(field) {
		return this[field].length >= 5;
	}

	validateAdditionalPropertie(model, data) {
		const obj = {};
		for (const key in data) {
			if (Object.hasOwnProperty.call(data, key)) {
				let element = data[key];
				const modelProp = model.category.json_base.properties.additional_info.properties[key];

				if (!modelProp) {
					continue;
				}
				if (Object.hasOwnProperty.call(modelProp, "format")) {
					if (Array.isArray(modelProp.type)) {
						if (modelProp.type[0] === "string" && modelProp.format === "date") {
							element = element ? DateUtils.toDefaultDateTime(element, "YYYY-MM-DD") : null;
						}
					} else {
						if (modelProp.type === "string" && modelProp.format === "date") {
							element = element ? DateUtils.toDefaultDateTime(element, "YYYY-MM-DD") : null;
						}
					}
				}

				if (Object.hasOwnProperty.call(modelProp, "type")) {
					if (Array.isArray(modelProp.type)) {
						if (modelProp.type[0] === "string") {
							if (element && element.trim().length > 0) {
								element = element.trim();
							} else {
								element = null;
							}
						}
					} else {
						if (modelProp.type === "string") {
							if (element && element.trim().length > 0) {
								element = element.trim();
							} else {
								element = null;
							}
						}
					}

					if (Array.isArray(modelProp.type)) {
						if (modelProp.type[0] === "number") {
							element = parseFloat(element);
							if (isNaN(element)) {
								element = null;
							}
						}
					} else {
						if (modelProp.type === "number") {
							element = parseFloat(element);
							if (isNaN(element)) {
								element = null;
							}
						}
					}
				}
				obj[key] = element;
			}
		}
		return obj;
	}
}
